// src/utils/bulkOrderNotification.tsx
import toast from 'react-hot-toast';
import { IoClose } from 'react-icons/io5';

export const showBulkOrderNotification = () => {
    toast.dismiss();
    toast.custom((t) => (
        <div
            className={`${t.visible ? 'animate-drop-in' : 'animate-drop-out'
                } max-w-md w-full bg-gradient-to-r from-orange-50 to-amber-100 shadow-xl rounded-xl pointer-events-auto flex ring-1 ring-orange-200 relative overflow-hidden`}
        >
            <button
                onClick={() => toast.dismiss(t.id)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors p-1"
            >
                <IoClose size={18} />
            </button>

            <div className="flex-1 w-0 p-4">
                <div className="flex items-start">
                    <div className="ml-3 flex-1">
                        <p className="text-sm font-bold text-orange-900 mb-2">
                            Maximum Quantity Reached
                        </p>
                        <p className="text-sm text-orange-800 mb-3">
                            You can order up to 5 items at a time. For bulk orders, please contact our team.
                        </p>
                        <a
                            href="tel:+917973938627"
                            onClick={() => toast.dismiss(t.id)}
                            className="inline-block text-xs font-bold text-white bg-orange-600 hover:bg-orange-700 px-4 py-2 rounded-lg shadow-sm transition-colors"
                        >
                            📞 Call +91-7973938627
                        </a>
                    </div>
                </div>
            </div>
        </div>
    ), {
        duration: 6000,
        position: 'top-center',
    });
};

export const showFreeProductLimitNotification = () => {
    toast.dismiss();
    toast.custom((t) => (
        <div
            className={`${t.visible ? 'animate-drop-in' : 'animate-drop-out'
                } max-w-md w-full bg-gradient-to-r from-blue-50 to-indigo-100 shadow-xl rounded-xl pointer-events-auto flex ring-1 ring-blue-200 relative overflow-hidden`}
        >
            <button
                onClick={() => toast.dismiss(t.id)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors p-1"
            >
                <IoClose size={18} />
            </button>

            <div className="flex-1 w-0 p-4">
                <div className="flex items-start">
                    <div className="ml-3 flex-1">
                        <p className="text-sm font-bold text-blue-900 mb-2">
                            Free Gift Limit
                        </p>
                        <p className="text-sm text-blue-800 mb-3">
                            Only one free product can be added per order. Enjoy your special gift!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    ), {
        duration: 5000,
        position: 'top-center',
    });
};
